// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tim-row {
    margin-bottom: 20px;
}

.tim-white-buttons {
    background-color: #777777;
}

.typography-line {
    padding-left: 25%;
    margin-bottom: 35px;
    position: relative;
    display: block;
    width: 100%;
}

.typography-line span {
    bottom: 10px;
    color: #c0c1c2;
    display: block;
    font-weight: 400;
    font-size: 13px;
    line-height: 13px;
    left: 0;
    position: absolute;
    width: 260px;
    text-transform: none;
}

.tim-row {
    padding-top: 60px;
}

.tim-row h3 {
    margin-top: 0;
}

.card #chartPreferences {
    width: 60%;
    margin: 0 auto;
}

#navbar-full .navbar {
    border-radius: 0 !important;
    margin-bottom: 15px;
    z-index: 2;
}

#map {
    position: relative;
    width: 100%;
    height: 100vh;
}

.places-buttons .btn {
    margin-bottom: 30px;
}

.map-container {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
}

#menu-dropdown .navbar {
    border-radius: 3px;
}

#pagination-row .pagination-container {
    height: 100%;
    max-height: 100%;
    display: flex;
    align-items: center;
}

.all-icons .font-icon-detail {
    text-align: center;
    padding: 45px 0px 30px;
    border: 1px solid #e5e5e5;
    border-radius: 0.1875rem;
    margin: 15px 0;
    min-height: 168px;
}

.all-icons [class*="now-ui-icons"] {
    font-size: 32px;
}

.all-icons .font-icon-detail p {
    margin: 25px auto 0;
    width: 100%;
    text-align: center;
    display: block;
    color: #B8B8B8;
    padding: 0 10px;
    font-size: 0.7142em;
}

#icons-row i.now-ui-icons {
    font-size: 30px;
}

.space {
    height: 130px;
    display: block;
}

.space-110 {
    height: 110px;
    display: block;
}

.space-50 {
    height: 50px;
    display: block;
}

.space-70 {
    height: 70px;
    display: block;
}

.navigation-example .img-src {
    background-attachment: scroll;
}

.navigation-example {
    background-position: center center;
    background-size: cover;
    margin-top: 0;
    min-height: 740px;
}

#notifications {
    background-color: #FFFFFF;
    display: block;
    width: 100%;
    position: relative;
}

.tim-note {
    text-transform: capitalize;
}

#buttons .btn,
#javascriptComponents .btn {
    margin: 0 0px 10px;
}

.space-100 {
    height: 100px;
    display: block;
    width: 100%;
}

.be-social {
    padding-bottom: 20px;
    /*     border-bottom: 1px solid #aaa; */
    margin: 0 auto 40px;
}

.txt-white {
    color: #FFFFFF;
}

.txt-gray {
    color: #ddd !important;
}

.parallax {
    width: 100%;
    height: 570px;
    display: block;
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
}

.logo-container .logo {
    overflow: hidden;
    border-radius: 50%;
    border: 1px solid #333333;
    width: 50px;
    float: left;
}

.logo-container .brand {
    font-size: 16px;
    color: #FFFFFF;
    line-height: 18px;
    float: left;
    margin-left: 10px;
    margin-top: 7px;
    width: 70px;
    height: 40px;
    text-align: left;
}

.logo-container .brand-material {
    font-size: 18px;
    margin-top: 15px;
    height: 25px;
    width: auto;
}

.logo-container .logo img {
    width: 100%;
}

.navbar-small .logo-container .brand {
    color: #333333;
}

.fixed-section {
    top: 90px;
    max-height: 80vh;
    overflow: scroll;
    position: sticky;
}

.fixed-section ul {
    padding: 0;
}

.fixed-section ul li {
    list-style: none;
}

.fixed-section li a {
    font-size: 14px;
    padding: 2px;
    display: block;
    color: #666666;
}

.fixed-section li a.active {
    color: #00bbff;
}

.fixed-section.float {
    position: fixed;
    top: 100px;
    width: 200px;
    margin-top: 0;
}

.parallax .parallax-image {
    width: 100%;
    overflow: hidden;
    position: absolute;
}

.parallax .parallax-image img {
    width: 100%;
}

@media (max-width: 768px) {
    .parallax .parallax-image {
        width: 100%;
        height: 640px;
        overflow: hidden;
    }
    .parallax .parallax-image img {
        height: 100%;
        width: auto;
    }
}

/*.separator{
    content: "Separator";
    color: #FFFFFF;
    display: block;
    width: 100%;
    padding: 20px;
}
.separator-line{
    background-color: #EEE;
    height: 1px;
    width: 100%;
    display: block;
}
.separator.separator-gray{
    background-color: #EEEEEE;
}*/

.social-buttons-demo .btn {
    margin-right: 5px;
    margin-bottom: 7px;
}

.img-container {
    width: 100%;
    overflow: hidden;
}

.img-container img {
    width: 100%;
}

.lightbox img {
    width: 100%;
}

.lightbox .modal-content {
    overflow: hidden;
}

.lightbox .modal-body {
    padding: 0;
}

@media screen and (min-width: 991px) {
    .lightbox .modal-dialog {
        width: 960px;
    }
}

@media (max-width: 991px) {
    .fixed-section.affix {
        position: relative;
        margin-bottom: 100px;
    }
}

@media (max-width: 768px) {
    .btn,
    .btn-morphing {
        margin-bottom: 10px;
    }
    .parallax .motto {
        top: 170px;
        margin-top: 0;
        font-size: 60px;
        width: 270px;
    }
}

/*       Loading dots  */

/*      transitions */

.presentation .front,
.presentation .front:after,
.presentation .front .btn,
.logo-container .logo,
.logo-container .brand {
    transition: all .2s;
}

#images h4 {
    margin-bottom: 30px;
}

#javascriptComponents {
    padding-bottom: 0;
}

/*      layer animation          */

.layers-container {
    display: block;
    margin-top: 50px;
    position: relative;
}

.layers-container img {
    position: absolute;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
    text-align: center;
}

.animate {
    transition: 1.5s ease-in-out;
    -moz-transition: 1.5s ease-in-out;
    -webkit-transition: 1.5s ease-in-out;
}

.navbar-default.navbar-small .logo-container .brand {
    color: #333333;
}

.navbar-transparent.navbar-small .logo-container .brand {
    color: #FFFFFF;
}

.navbar-default.navbar-small .logo-container .brand {
    color: #333333;
}

.sharing-area {
    margin-top: 80px;
}

.sharing-area .btn {
    margin: 15px 4px 0;
}

.section-thin,
.section-notifications {
    padding: 0;
}

.section-navbars {
    padding-top: 0;
}

#navbar .navbar {
    margin-bottom: 20px;
}

#navbar .navbar-toggler,
#menu-dropdown .navbar-toggler {
    pointer-events: none;
}

.section-tabs {
    background: #EEEEEE;
}

.section-pagination {
    padding-bottom: 0;
}

.section-download {
    padding-top: 130px;
}

.section-download .description {
    margin-bottom: 60px;
}

.section-download h4 {
    margin-bottom: 25px;
}

.section-examples a {
    text-decoration: none;
}

.section-examples a+a {
    margin-top: 30px;
}

.section-examples h5 {
    margin-top: 30px;
}

.components-page .wrapper>.header,
.tutorial-page .wrapper>.header {
    height: 500px;
    padding-top: 128px;
    background-size: cover;
    background-position: center center;
}

.components-page .title,
.tutorial-page .title {
    color: #FFFFFF;
}

.brand .h1-seo {
    font-size: 2.8em;
    text-transform: uppercase;
    font-weight: 300;
}

.brand .n-logo {
    max-width: 100px;
    margin-bottom: 40px;
}

.invision-logo {
    max-width: 70px;
    top: -2px;
    position: relative;
}

.creative-tim-logo {
    max-width: 140px;
    top: -2px;
    position: relative;
}

.section-javascript .title {
    margin-bottom: 0;
}

.navbar .switch-background {
    display: block;
}

.navbar-transparent .switch-background {
    display: none;
}

.section-signup .col .btn {
    margin-top: 30px;
}

#buttons-row .btn {
    margin-bottom: 10px;
}

.section-navbars .navbar-collapse {
    display: none;
}

.section-basic {
    padding-top: 0;
}

.section-images {
    padding-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/demo.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,OAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;IACxB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;;;;;;;;;;;;;;;EAeE;;AAEF;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;IACxB;AACJ;;AAEA;IACI;;QAEI,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,aAAa;QACb,eAAe;QACf,YAAY;IAChB;AACJ;;AAEA,wBAAwB;;AAExB,qBAAqB;;AAErB;;;;;IAQI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,kCAAkC;;AAElC;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".tim-row {\n    margin-bottom: 20px;\n}\n\n.tim-white-buttons {\n    background-color: #777777;\n}\n\n.typography-line {\n    padding-left: 25%;\n    margin-bottom: 35px;\n    position: relative;\n    display: block;\n    width: 100%;\n}\n\n.typography-line span {\n    bottom: 10px;\n    color: #c0c1c2;\n    display: block;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 13px;\n    left: 0;\n    position: absolute;\n    width: 260px;\n    text-transform: none;\n}\n\n.tim-row {\n    padding-top: 60px;\n}\n\n.tim-row h3 {\n    margin-top: 0;\n}\n\n.card #chartPreferences {\n    width: 60%;\n    margin: 0 auto;\n}\n\n#navbar-full .navbar {\n    border-radius: 0 !important;\n    margin-bottom: 15px;\n    z-index: 2;\n}\n\n#map {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n}\n\n.places-buttons .btn {\n    margin-bottom: 30px;\n}\n\n.map-container {\n    width: 100%;\n    height: 100vh;\n    max-height: 100vh;\n}\n\n#menu-dropdown .navbar {\n    border-radius: 3px;\n}\n\n#pagination-row .pagination-container {\n    height: 100%;\n    max-height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.all-icons .font-icon-detail {\n    text-align: center;\n    padding: 45px 0px 30px;\n    border: 1px solid #e5e5e5;\n    border-radius: 0.1875rem;\n    margin: 15px 0;\n    min-height: 168px;\n}\n\n.all-icons [class*=\"now-ui-icons\"] {\n    font-size: 32px;\n}\n\n.all-icons .font-icon-detail p {\n    margin: 25px auto 0;\n    width: 100%;\n    text-align: center;\n    display: block;\n    color: #B8B8B8;\n    padding: 0 10px;\n    font-size: 0.7142em;\n}\n\n#icons-row i.now-ui-icons {\n    font-size: 30px;\n}\n\n.space {\n    height: 130px;\n    display: block;\n}\n\n.space-110 {\n    height: 110px;\n    display: block;\n}\n\n.space-50 {\n    height: 50px;\n    display: block;\n}\n\n.space-70 {\n    height: 70px;\n    display: block;\n}\n\n.navigation-example .img-src {\n    background-attachment: scroll;\n}\n\n.navigation-example {\n    background-position: center center;\n    background-size: cover;\n    margin-top: 0;\n    min-height: 740px;\n}\n\n#notifications {\n    background-color: #FFFFFF;\n    display: block;\n    width: 100%;\n    position: relative;\n}\n\n.tim-note {\n    text-transform: capitalize;\n}\n\n#buttons .btn,\n#javascriptComponents .btn {\n    margin: 0 0px 10px;\n}\n\n.space-100 {\n    height: 100px;\n    display: block;\n    width: 100%;\n}\n\n.be-social {\n    padding-bottom: 20px;\n    /*     border-bottom: 1px solid #aaa; */\n    margin: 0 auto 40px;\n}\n\n.txt-white {\n    color: #FFFFFF;\n}\n\n.txt-gray {\n    color: #ddd !important;\n}\n\n.parallax {\n    width: 100%;\n    height: 570px;\n    display: block;\n    background-attachment: fixed;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n}\n\n.logo-container .logo {\n    overflow: hidden;\n    border-radius: 50%;\n    border: 1px solid #333333;\n    width: 50px;\n    float: left;\n}\n\n.logo-container .brand {\n    font-size: 16px;\n    color: #FFFFFF;\n    line-height: 18px;\n    float: left;\n    margin-left: 10px;\n    margin-top: 7px;\n    width: 70px;\n    height: 40px;\n    text-align: left;\n}\n\n.logo-container .brand-material {\n    font-size: 18px;\n    margin-top: 15px;\n    height: 25px;\n    width: auto;\n}\n\n.logo-container .logo img {\n    width: 100%;\n}\n\n.navbar-small .logo-container .brand {\n    color: #333333;\n}\n\n.fixed-section {\n    top: 90px;\n    max-height: 80vh;\n    overflow: scroll;\n    position: sticky;\n}\n\n.fixed-section ul {\n    padding: 0;\n}\n\n.fixed-section ul li {\n    list-style: none;\n}\n\n.fixed-section li a {\n    font-size: 14px;\n    padding: 2px;\n    display: block;\n    color: #666666;\n}\n\n.fixed-section li a.active {\n    color: #00bbff;\n}\n\n.fixed-section.float {\n    position: fixed;\n    top: 100px;\n    width: 200px;\n    margin-top: 0;\n}\n\n.parallax .parallax-image {\n    width: 100%;\n    overflow: hidden;\n    position: absolute;\n}\n\n.parallax .parallax-image img {\n    width: 100%;\n}\n\n@media (max-width: 768px) {\n    .parallax .parallax-image {\n        width: 100%;\n        height: 640px;\n        overflow: hidden;\n    }\n    .parallax .parallax-image img {\n        height: 100%;\n        width: auto;\n    }\n}\n\n/*.separator{\n    content: \"Separator\";\n    color: #FFFFFF;\n    display: block;\n    width: 100%;\n    padding: 20px;\n}\n.separator-line{\n    background-color: #EEE;\n    height: 1px;\n    width: 100%;\n    display: block;\n}\n.separator.separator-gray{\n    background-color: #EEEEEE;\n}*/\n\n.social-buttons-demo .btn {\n    margin-right: 5px;\n    margin-bottom: 7px;\n}\n\n.img-container {\n    width: 100%;\n    overflow: hidden;\n}\n\n.img-container img {\n    width: 100%;\n}\n\n.lightbox img {\n    width: 100%;\n}\n\n.lightbox .modal-content {\n    overflow: hidden;\n}\n\n.lightbox .modal-body {\n    padding: 0;\n}\n\n@media screen and (min-width: 991px) {\n    .lightbox .modal-dialog {\n        width: 960px;\n    }\n}\n\n@media (max-width: 991px) {\n    .fixed-section.affix {\n        position: relative;\n        margin-bottom: 100px;\n    }\n}\n\n@media (max-width: 768px) {\n    .btn,\n    .btn-morphing {\n        margin-bottom: 10px;\n    }\n    .parallax .motto {\n        top: 170px;\n        margin-top: 0;\n        font-size: 60px;\n        width: 270px;\n    }\n}\n\n/*       Loading dots  */\n\n/*      transitions */\n\n.presentation .front,\n.presentation .front:after,\n.presentation .front .btn,\n.logo-container .logo,\n.logo-container .brand {\n    -webkit-transition: all .2s;\n    -moz-transition: all .2s;\n    -o-transition: all .2s;\n    transition: all .2s;\n}\n\n#images h4 {\n    margin-bottom: 30px;\n}\n\n#javascriptComponents {\n    padding-bottom: 0;\n}\n\n/*      layer animation          */\n\n.layers-container {\n    display: block;\n    margin-top: 50px;\n    position: relative;\n}\n\n.layers-container img {\n    position: absolute;\n    width: 100%;\n    height: auto;\n    top: 0;\n    left: 0;\n    text-align: center;\n}\n\n.animate {\n    transition: 1.5s ease-in-out;\n    -moz-transition: 1.5s ease-in-out;\n    -webkit-transition: 1.5s ease-in-out;\n}\n\n.navbar-default.navbar-small .logo-container .brand {\n    color: #333333;\n}\n\n.navbar-transparent.navbar-small .logo-container .brand {\n    color: #FFFFFF;\n}\n\n.navbar-default.navbar-small .logo-container .brand {\n    color: #333333;\n}\n\n.sharing-area {\n    margin-top: 80px;\n}\n\n.sharing-area .btn {\n    margin: 15px 4px 0;\n}\n\n.section-thin,\n.section-notifications {\n    padding: 0;\n}\n\n.section-navbars {\n    padding-top: 0;\n}\n\n#navbar .navbar {\n    margin-bottom: 20px;\n}\n\n#navbar .navbar-toggler,\n#menu-dropdown .navbar-toggler {\n    pointer-events: none;\n}\n\n.section-tabs {\n    background: #EEEEEE;\n}\n\n.section-pagination {\n    padding-bottom: 0;\n}\n\n.section-download {\n    padding-top: 130px;\n}\n\n.section-download .description {\n    margin-bottom: 60px;\n}\n\n.section-download h4 {\n    margin-bottom: 25px;\n}\n\n.section-examples a {\n    text-decoration: none;\n}\n\n.section-examples a+a {\n    margin-top: 30px;\n}\n\n.section-examples h5 {\n    margin-top: 30px;\n}\n\n.components-page .wrapper>.header,\n.tutorial-page .wrapper>.header {\n    height: 500px;\n    padding-top: 128px;\n    background-size: cover;\n    background-position: center center;\n}\n\n.components-page .title,\n.tutorial-page .title {\n    color: #FFFFFF;\n}\n\n.brand .h1-seo {\n    font-size: 2.8em;\n    text-transform: uppercase;\n    font-weight: 300;\n}\n\n.brand .n-logo {\n    max-width: 100px;\n    margin-bottom: 40px;\n}\n\n.invision-logo {\n    max-width: 70px;\n    top: -2px;\n    position: relative;\n}\n\n.creative-tim-logo {\n    max-width: 140px;\n    top: -2px;\n    position: relative;\n}\n\n.section-javascript .title {\n    margin-bottom: 0;\n}\n\n.navbar .switch-background {\n    display: block;\n}\n\n.navbar-transparent .switch-background {\n    display: none;\n}\n\n.section-signup .col .btn {\n    margin-top: 30px;\n}\n\n#buttons-row .btn {\n    margin-bottom: 10px;\n}\n\n.section-navbars .navbar-collapse {\n    display: none;\n}\n\n.section-basic {\n    padding-top: 0;\n}\n\n.section-images {\n    padding-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
